import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { SchedulesService } from "@services/schedules.service";


@Injectable()
export class SchedulesResolver  {
    constructor(
        private schedulesSrv: SchedulesService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.schedulesSrv.get()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
